import { Share } from '@mui/icons-material';
import { Divider } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const BannerOne = ({ img, title, subtitle = "", tag = "" }) => {
    const handleShare = async () => {
        const host = window.location.hostname;
        const port = window.location.port;
        const pathname = window.location.pathname;
        const protocol = window.location.protocol;
        const url = `${protocol}//${host}${port ? `:${port}` : ''}${pathname}`;

        const shareData = {
            title,
            text: `Check out this post: ${title}`,
            url,
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData);
                console.log('Shared successfully');
            } else {
                await navigator.clipboard.writeText(url);
                console.log('URL copied to clipboard');
            }
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    return (
        <div>
            <div className='banner-hero'>
                <img src={img} alt={title} />
                <div className="banner-hero-overlay" />
                <div className="banner-hero-content">
                    {tag && <span className="banner-hero-tag">{tag}</span>}
                    <h1
                            style={{
                                fontWeight: "bolder",
                                fontSize: "3rem",
                                color: "#fff",
                                fontFamily: "Poppins, sans-serif",
                                lineHeight: 1.05
                            }}
                        >
                            {title}
                        </h1>
                    {subtitle && <p>{subtitle}</p>}
                </div>
            </div>
            
           
        </div>
    );
};

export default BannerOne;
